<mat-card class="form-view-step-3">
  <h2 mat-dialog-title mat-dialog-draggable-title style="margin-bottom: 0 !important; font-weight: 700;">
    {{ "add_document_moha.labor_contract_report_information" | translate }}
    <button type="button" class="close" aria-label="Close" (click)="onNoClick()">
      <span aria-hidden="true">&times;</span>
    </button>
  </h2>
  <mat-divider></mat-divider>

  <mat-card-content class="mb-3 mat-card-content-contract-sm">
    <div class="employee-info">
      <span class="employee-label">{{ "add_document_moha.employee" | translate }}:</span>
      <strong>{{ customerMohaName }}</strong>
    </div>

    <mat-accordion [multi]="true">
      <mat-expansion-panel expanded="true" class="mt-3 mat-elevation-z0">
        <mat-expansion-panel *ngIf="isOriginalContract" expanded="true" class="mat-elevation-z0">
          <mat-expansion-panel-header>
            <mat-panel-description class="mat-panel-title">
              {{ titleChange }} &nbsp;
            </mat-panel-description>
          </mat-expansion-panel-header>
          <ng-container
            [ngTemplateOutlet]="criteriaTree"
            [ngTemplateOutletContext]="{
              rows: listDataUpdateTable,
              nameHeader: 'labor_utilization_report.criterion_name',
              valueHeader: 'labor_utilization_report.template_information_fields'
            }">
          </ng-container>
        </mat-expansion-panel>

        <mat-expansion-panel expanded="true" class="mt-3 mat-elevation-z0">
          <mat-expansion-panel-header>
            <mat-panel-description class="mat-panel-title">
              {{ "add_document_moha.list_report_contract" | translate }} &nbsp;
            </mat-panel-description>
          </mat-expansion-panel-header>
          <ng-container
            [ngTemplateOutlet]="criteriaTree"
            [ngTemplateOutletContext]="{
              rows: listDataTable,
              nameHeader: 'add_document_moha.criteria_name',
              valueHeader: 'handsontable.title.value'
            }">
          </ng-container>
        </mat-expansion-panel>
      </mat-expansion-panel>
    </mat-accordion>
  </mat-card-content>

  <div mat-dialog-actions class="justify-content-center">
    <button mat-stroked-button color="primary" class="mr-3" [mat-dialog-close]="true">
      <mat-icon class="mr-0">cancel</mat-icon>
      {{ "button.close" | translate }}
    </button>
  </div>
</mat-card>

<ng-template #criteriaTree let-rows="rows" let-nameHeader="nameHeader" let-valueHeader="valueHeader">
  <div class="criteria-table-wrapper">
    <mat-table [dataSource]="rows" [trackBy]="trackByTreeKey" class="criteria-table">
      <ng-container matColumnDef="groupHeader">
        <mat-cell *matCellDef="let element" class="group-header-cell">
          <button mat-icon-button type="button" class="toggle-button" (click)="toggleGroup(element)">
            <ng-container *ngIf="!element.expanded"> 
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6 8H10M8 6V10M2 3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H12.6667C13.0203 2 13.3594 2.14048 13.6095 2.39052C13.8595 2.64057 14 2.97971 14 3.33333V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V3.33333Z" stroke="#6F767E" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
          </ng-container>
          <ng-container *ngIf="element.expanded"> 
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.33333 8H10.6667M5.2 14H10.8C11.9201 14 12.4802 14 12.908 13.782C13.2843 13.5903 13.5903 13.2843 13.782 12.908C14 12.4802 14 11.9201 14 10.8V5.2C14 4.0799 14 3.51984 13.782 3.09202C13.5903 2.71569 13.2843 2.40973 12.908 2.21799C12.4802 2 11.9201 2 10.8 2H5.2C4.0799 2 3.51984 2 3.09202 2.21799C2.71569 2.40973 2.40973 2.71569 2.21799 3.09202C2 3.51984 2 4.0799 2 5.2V10.8C2 11.9201 2 12.4802 2.21799 12.908C2.40973 13.2843 2.71569 13.5903 3.09202 13.782C3.51984 14 4.0799 14 5.2 14Z" stroke="#6B7280" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
          </ng-container>
          </button>
          <strong>{{ element.name }}</strong>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="stt">
        <mat-header-cell *matHeaderCellDef class="mat-cell-non-boder-right-bottom">
          {{ "headertable.stt" | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom">
          <button *ngIf="element.rowType === 'subheader'" mat-icon-button type="button"
            class="toggle-button" (click)="toggleGroup(element)">
            <mat-icon>{{ element.expanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}</mat-icon>
          </button>
          <span *ngIf="!element.level || element.level <= 1">{{ element.displayOrder }}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="nameCriteria">
        <mat-header-cell *matHeaderCellDef class="mat-cell-non-boder-right-bottom">
          {{ nameHeader | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let element" [matTooltip]="element.name"
          [class.subheader-name]="element.rowType === 'subheader'"
          class="mat-cell-non-boder-right-bottom cell">
          <span class="nameDoc">
            <span *ngIf="element.level > 1" class="child-display-order">{{ element.displayOrder }}</span>
            {{ element.name }}
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="infoTemplate">
        <mat-header-cell *matHeaderCellDef class="text-center mat-cell-non-boder-right-bottom">
          {{ valueHeader | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom">
          <span *ngIf="element.rowType === 'criterion'" class="view-value"
            [matTooltip]="getDisplayValue(element)">
            {{ getDisplayValue(element) }}
          </span>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: headerColumns; when: isHeaderRow"
        [class.row-hidden]="!isRowVisible(row)" class="group-header-row">
      </mat-row>
      <mat-row *matRowDef="let row; columns: displayedColumns; when: isCriterionRow"
        [class.subheader-row]="row.rowType === 'subheader'"
        [class.row-hidden]="!isRowVisible(row)" class="criterion-row">
      </mat-row>
    </mat-table>
  </div>
</ng-template>
